module.exports = function anonymous(locals, escapeFn, include, rethrow
/**/) {
"use strict";
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
        .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
    ; __append("<div class=\"row\"> ")
    ;  _(locals.choices).each(function(choice) { 
    ; __append(" <div class=\"col-3\"> <a class=\"image-choice d-block border-radius ")
    ; __append(escapeFn( locals.currentChoice.option === choice.option ? 'border-secondary' : 'border-gray-200' ))
    ; __append("\"> <img src=\"")
    ; __append(escapeFn( choice.src ))
    ; __append("\" alt=\"")
    ; __append(escapeFn( choice.option ))
    ; __append("\" data-option=\"")
    ; __append(escapeFn( choice.option ))
    ; __append("\" class=\"img-fluid\"> </a> </div> ")
    ;  }); 
    ; __append(" </div> ")
  return __output.join("");

}


//////////////////
// WEBPACK FOOTER
// ./app/components/pages/brand/image_selector/template.ejs
// module id = 1306
// module chunks = 1